import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/_externalProjectionsLayout/dashboards/edit/$id/audit')(
  {
    beforeLoad: () => getAuditLogsTitleContextSlice(),
    staticData: {
      owner: CodeOwner.Analytics,
    },
  }
);
